// Copyright (c) StrangeBee 2024

import { ProfileController, ProfileOutput } from 'thehive-sdk';
import { ProfileValuesForm } from './ProfileManage/ProfileForm';

export interface ProfileEventListOutput {
    onListAll: () => Promise<ProfileOutput[]>;
    onCreate: (value: ProfileValuesForm) => void;
    onEdit: ({ name, ...rest }: ProfileValuesForm) => void;
    onDelete: (profileId: string) => void;
}

interface ProfileEventListParams {
    controller: ProfileController;
    locale?: (label: string) => string;
    onSuccess?: (count?: boolean, message?: string) => void;
    onError?: any;
}

export const computeEventList = ({
    controller,
    locale,
    onSuccess,
    onError,
}: ProfileEventListParams): ProfileEventListOutput => ({
    onListAll: (): Promise<ProfileOutput[]> =>
        controller.list({ selector: { head: [{ name: 'listProfile' }], name: 'list-all-profiles' } }),

    onCreate: (value: ProfileValuesForm): void => {
        controller
            .create(value)
            .then(() => onSuccess?.(true, locale?.('notification.profile.create') || 'success'))
            .catch(onError);
    },

    onEdit: ({ name, ...rest }: ProfileValuesForm): void => {
        controller
            .edit(rest, name)
            .then(() => onSuccess?.(false, locale?.('notification.profile.edit') || 'success'))
            .catch(onError);
    },

    onDelete: (profileId: string): void => {
        controller
            .delete(profileId)
            .then(() => onSuccess?.(true, locale?.('notification.profile.delete') || 'success'))
            .catch(onError);
    },
});
